import * as React from "react"
import classNames from "classnames"
import Block from "@bappweb/block"
import Footer from "@components/globalmodules/footer"
import "./style.scss"

interface Props {
  children: React.ReactNode
  className?: string
  container?: boolean
  footer?: boolean
  padding?: boolean
}

const Page = ({ children, className, container = true, footer = true, padding = true }: Props) => {
  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  if (footer) {
    return (
      <>
        <Block
          className={classNames(
            "bapp-page",
            {
              "bapp-container": container,
              "bapp-page-has-padding": padding,
              "bapp-page-has-footer": footer
            },
            className
          )}>
          {children}
        </Block>
        <Footer />
      </>
    )
  }

  return (
    <Block
      className={classNames(
        "bapp-page",
        {
          "bapp-container": container,
          "bapp-page-has-padding": padding
        },
        className
      )}>
      {children}
    </Block>
  )
}

export default Page
